import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

export const CloseIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="19.5" fill="white" stroke="#D9D9D9" />
      <rect x="12" y="14" width="16" height="2" rx="1" fill="black" />
      <rect x="12" y="19" width="16" height="2" rx="1" fill="black" />
      <rect x="12" y="24" width="16" height="2" rx="1" fill="black" />
      <circle cx="20" cy="20" r="19.5" fill="white" stroke="#D9D9D9" />
      <path
        d="M14.3386 25.9661L25.6523 14.6523"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14.3477 14.6523L25.6614 25.9661"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </SvgIcon>
);

export default CloseIcon;
